import http from "../httpService";
import { apiUrl } from "../../../config.js";
import { DateTime } from "luxon";

const apiEndpoint = apiUrl + "/sales/discount/";

export function getDiscounts() {
  return http.get(apiEndpoint);
}

export function getDiscount(discountID) {
  return http.get(apiEndpoint + "discount-detail/" + discountID);
}

export function saveDiscount(discount) {
  return http.post(apiEndpoint, discount);
}

export function deleteDiscount(discountID) {
  return http.delete(apiEndpoint + discountID);
}

export function checkDiscount(
  sales = {
    documentType: "",
    documentDate: DateTime.now().startOf("day"),
    currencyID: 0,
    exchangeRate: 1,
    grandTotal: 0,
    salesItem: [
      {
        ItemID: 0,
        VarCode: "",
        Qty: 0,
        UomID: 0,
      },
    ],
  }
) {
  return http.post(apiEndpoint + "check-discount", sales);
}

export function getDiscountTriggerItem(itemID = 0, itemPackageID = 0) {
  return http.get(
    apiEndpoint + "check-trigger-item/" + itemID + "/" + itemPackageID
  );
}
